import IconChevronDown from './icon-chevron-down.svg'
import IconPlus from './icon-plus.svg'
import IconSearch from './icon-search.svg'
import IconSearchWhite from './icon-search-white.svg'
import IconArrowRight from './icon-arrow-right.svg'
import IconArrowGreen from './icon-arrow-green.svg'
import IconCustomData from './icon-custom-data.svg'
import IconClose from './icon-close.svg'
import IconMetric from './icon-metric.svg'
import IconCompare from './icon-compare.svg'
import IconCategory from './icon-category.svg'
import IconRole from './icon-role.svg'
import IconNoSearch from './icon-no-search.svg'
import IconExpand from './icon-expand.svg'
import IconQuestionCircle from './icon-question-circle.svg'
import IconUser from './icon-user.svg'
import IconChevronDownLine from './icon-chevron-down-line.svg'
import IconSort from './icon-sort.svg'
import IconSortList from './icon-sort-list.svg'
import IconGoal from './icon-goal.svg'
import IconArrowUp from './icon-arrow-up.svg'
import IconArrowDown from './icon-arrow-down.svg'
import IconLastUpdated from './icon-last-updated.svg'
import IconCheckmark from './icon-checkmark.svg'

export default {
  'icon-chevron-down': IconChevronDown,
  'icon-checkmark': IconCheckmark,
  'icon-plus': IconPlus,
  'icon-search': IconSearch,
  'icon-search-white': IconSearchWhite,
  'icon-arrow-right': IconArrowRight,
  'icon-arrow-green': IconArrowGreen,
  'icon-custom-data': IconCustomData,
  'icon-close': IconClose,
  'icon-metric': IconMetric,
  'icon-compare': IconCompare,
  'icon-category': IconCategory,
  'icon-role': IconRole,
  'icon-no-search': IconNoSearch,
  'icon-expand': IconExpand,
  'icon-question-circle': IconQuestionCircle,
  'icon-user': IconUser,
  'icon-chevron-down-line': IconChevronDownLine,
  'icon-sort': IconSort,
  'icon-sort-list': IconSortList,
  'icon-goal': IconGoal,
  'icon-arrow-down': IconArrowDown,
  'icon-arrow-up': IconArrowUp,
  'icon-last-updated': IconLastUpdated,
}
